export interface InternalReportMetaItem {
  label: string;
  value: string;
}

interface InternalReportMetaHeaderProps {
  items: InternalReportMetaItem[];
}

const InternalReportMetaHeader = ({ items }: InternalReportMetaHeaderProps) => (
  <div className="flex w-full items-start rounded-lg bg-[#F9FAFB] p-3">
    {items.map((item) => (
      <div key={item.label} className="flex min-w-0 flex-1 flex-col gap-1">
        <p className="text-xs leading-4 text-[#94A3B8]">{item.label}</p>
        <p className="text-sm leading-5 text-[#475569]">{item.value}</p>
      </div>
    ))}
  </div>
);

export default InternalReportMetaHeader;
